const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Infantry extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Infantry.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                (playerState) => playerState.militaryCalculationDelegate.push({
                    Source: this,
                    Action: () => this.GetWorkerCount() * multiplier,
                })
            }
        )
        // Strength of one unit (e.g. what sacrificing it is worth when colonizing)
        this.multiplier = multiplier;
    }
    static GetType = () => TechnologyTypes.Military.Infantry;
}

class Warrior extends Infantry {
    constructor(){
        super(Warrior.GetAge(), Warrior.GetName(), 0, 2, 1)
    }

    static GetInstance = () => new Warrior();
    static GetAge = () => Age.AgeA;
    static GetName = () => TechnologyNames.Military.Warrior;
}

class Swordsmen extends Infantry {
    constructor(){
        super(Swordsmen.GetAge(), Swordsmen.GetName(), 4, 3, 2)
    }

    static GetInstance = () => new Swordsmen();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Military.Swordsmen;
}

class Riflemen extends Infantry {
    constructor(){
        super(Riflemen.GetAge(), Riflemen.GetName(), 6, 5, 3)
    }

    static GetInstance = () => new Riflemen();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Military.Riflemen;
}

class ModernInfantry extends Infantry {
    constructor(){
        super(ModernInfantry.GetAge(), ModernInfantry.GetName(), 10, 7, 5)
    }

    static GetInstance = () => new ModernInfantry();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Military.ModernInfantry;
}

module.exports = {
    Warrior,
    Swordsmen,
    Riflemen,
    ModernInfantry
}